import React, { useState } from "react";
import { useAiring } from "hero/utils/timed";
import { View } from "./View";
import { getVariant } from "./variant";
export var Provider = function (_a) {
    var start = _a.start, end = _a.end, channel = _a.channel, cb = _a.cb, isColor = _a.isColor, isOrange = _a.isOrange, className = _a.className, _b = _a.disablePulsar, disablePulsar = _b === void 0 ? false : _b;
    var _c = useState(getVariant(start, end)), variant = _c[0], setVariant = _c[1];
    useAiring("AIRTIME", start, end, function () {
        setVariant(getVariant(start, end));
        if (cb)
            cb();
    });
    return (React.createElement(View, { variant: variant, channel: channel, className: className, isOrange: isOrange, isColor: isColor, disablePulsar: disablePulsar }));
};
